"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _buildOptions = _interopRequireDefault(require("./buildOptions"));
var _isMultiLevel = _interopRequireDefault(require("./isMultiLevel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function countOptions(options) {
  var availableOptions = [];
  if ((0, _isMultiLevel["default"])(options)) {
    availableOptions = (0, _buildOptions["default"])({
      options: options,
      selected: []
    });
    return _lodash["default"].filter(_lodash["default"].flattenDeep(availableOptions), function (o) {
      return !o.hasChildren;
    }).length;
  }
  return options.length;
}
var _default = exports["default"] = countOptions;